import React, { PureComponent } from 'react';
import Slider from 'react-slick';
import { UiScreenshots } from './homepage.consts';
import { track, TrackedEvent } from '../../core/analytics';
import './homepage-carousel.scss';

interface OwnProps {}

type Props = OwnProps;

interface State {
  centerSlider: Slider;
  fadeSlider: Slider;
  isFadeSliderHidden: boolean;
}

class HomepageCarousel extends PureComponent<Props, State> {
  centerSlider: Slider;
  fadeSlider: Slider;

  documentMouseDownHandler = (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest('.hero-header-center-slider')) {
      this.setState({
        isFadeSliderHidden: true,
      });
    }
  };

  documentMouseUpHandler = (e: MouseEvent) => {
    this.setState({
      isFadeSliderHidden: false,
    });
  };

  documentClickHandler = (e: MouseEvent) => {
    const slickDotsEl = (e.target as HTMLElement).closest('.slick-dots');
    if (slickDotsEl) {
      const index: number = Array.prototype.slice
        .call(slickDotsEl.querySelectorAll('li'))
        .findIndex((el) => (el as HTMLLIElement).classList.contains('slick-active'));
      track(TrackedEvent.homePageCarouselDotClicked, { index });
      return;
    }
    const slickCenterSliderTrackEl = (e.target as HTMLElement).closest(
      '.hero-header-center-slider>.slick-list>.slick-track'
    );
    if (slickCenterSliderTrackEl) {
      const sliderItemEl: HTMLElement = (e.target as HTMLElement).closest('.hero-header-slider-item') as HTMLElement;
      if (sliderItemEl) {
        const index: number = parseInt(sliderItemEl.dataset['index']);
        track(TrackedEvent.homePageCarouselItemClicked, { index });
        this.centerSlider.slickGoTo(index);
        return;
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      centerSlider: null,
      fadeSlider: null,
      isFadeSliderHidden: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.documentMouseDownHandler);
    document.addEventListener('mouseup', this.documentMouseUpHandler);
    document.addEventListener('click', this.documentClickHandler);
    this.setState({
      centerSlider: this.centerSlider,
      fadeSlider: this.fadeSlider,
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.documentMouseDownHandler);
    document.removeEventListener('mouseup', this.documentMouseUpHandler);
    document.removeEventListener('click', this.documentClickHandler);
  }

  render() {
    const { isFadeSliderHidden } = this.state;

    return (
      <React.Fragment>
        <div
          className={`hero-header-center-slider-container ${
            !!(this.state.centerSlider && this.state.fadeSlider) ? '' : 'hidden'
          }`}
        >
          <Slider
            infinite
            autoplay
            autoplaySpeed={3200}
            pauseOnFocus
            dots={false}
            arrows={false}
            centerMode
            speed={480}
            slidesToShow={3}
            className="hero-header-center-slider"
            asNavFor={this.state.fadeSlider}
            ref={(slider) => {
              this.centerSlider = slider;
            }}
            onSwipe={(direction) => {
              track(TrackedEvent.homePageCarouselSwipe, { direction });
            }}
          >
            {UiScreenshots.map((uiScreenshot, index) => {
              return (
                <div key={uiScreenshot.imageUrl} className="hero-header-slider-item" data-index={index}>
                  <img src={uiScreenshot.imageUrl} />
                </div>
              );
            })}
          </Slider>
        </div>
        <Slider
          infinite
          dots={true}
          arrows={false}
          speed={480}
          fade
          className={`hero-header-fade-slider ${isFadeSliderHidden ? 'slider-hidden' : ''}`}
          asNavFor={this.state.centerSlider}
          ref={(slider) => {
            this.fadeSlider = slider;
          }}
        >
          {UiScreenshots.map((uiScreenshot, index) => {
            return (
              <React.Fragment key={uiScreenshot.imageUrl}>
                <div className="hero-header-slider-item">
                  <img src={uiScreenshot.imageUrl} />
                </div>
                <div className="hero-header-slider-item-product-label">{uiScreenshot.productLabel}</div>
              </React.Fragment>
            );
          })}
        </Slider>
      </React.Fragment>
    );
  }
}

export default HomepageCarousel;
